function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#USDC_svg__clip0_1_122)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 30c8.313 0 15-6.687 15-15 0-8.313-6.687-15-15-15C6.687 0 0 6.687 0 15c0 8.313 6.687 15 15 15z",
  fill: "#2775CA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.125 17.375c0-2.188-1.313-2.938-3.938-3.251-1.874-.25-2.25-.75-2.25-1.625 0-.874.626-1.437 1.876-1.437 1.124 0 1.75.376 2.062 1.313a.47.47 0 00.438.312h1c.251 0 .439-.188.439-.438v-.063a3.122 3.122 0 00-2.813-2.562v-1.5c0-.25-.188-.438-.5-.5h-.937c-.25 0-.438.188-.5.5v1.437c-1.875.25-3.063 1.5-3.063 3.063 0 2.063 1.25 2.875 3.875 3.188 1.75.312 2.313.687 2.313 1.687s-.874 1.688-2.062 1.688c-1.625 0-2.188-.688-2.375-1.625-.063-.25-.25-.375-.438-.375H11.19a.427.427 0 00-.438.438v.063c.25 1.563 1.25 2.688 3.312 3v1.5c0 .25.188.438.5.5h.937c.25 0 .438-.188.5-.5v-1.5c1.874-.313 3.124-1.626 3.124-3.313z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.813 23.937c-4.875-1.75-7.376-7.188-5.562-12 .937-2.625 3-4.624 5.562-5.562.25-.124.375-.312.375-.625v-.875c0-.25-.125-.438-.375-.5-.063 0-.188 0-.25.064-5.938 1.875-9.188 8.187-7.313 14.125a11.245 11.245 0 007.312 7.313c.25.124.5 0 .563-.25.063-.064.063-.125.063-.251V24.5c0-.189-.188-.438-.375-.564zm6.625-19.5c-.25-.124-.5 0-.562.25-.063.064-.063.125-.063.251v.875c0 .25.187.5.375.625 4.875 1.75 7.375 7.188 5.562 12-.938 2.625-3 4.625-5.562 5.562-.25.125-.375.312-.375.626v.874c0 .25.124.438.375.5.063 0 .187 0 .25-.063 5.937-1.875 9.188-8.187 7.313-14.126a11.339 11.339 0 00-7.313-7.374z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "USDC_svg__clip0_1_122"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgUsdc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "7a691959cd0be56542ced2ba89e9dd49.svg";
export { SvgUsdc as ReactComponent };